import { defineMessages } from 'react-intl';

export const messages: {
	for: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.archived': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.off-track': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.at-risk': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.on-track': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.pending': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.paused': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.completed': {
		id: string;
		defaultMessage: string;
		description: string;
	};
	'townsquare.api.goal-state.cancelled': {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	for: {
		id: 'search-page.atlas.goal.for',
		defaultMessage: 'for',
		description: 'The conjunction between a status and date e.g. "On track for August"',
	},
	'townsquare.api.goal-state.archived': {
		id: 'seaech-page.townsquare.api.goal-state.archived',
		defaultMessage: 'Archived',
		description: 'Label of Archived state',
	},
	'townsquare.api.goal-state.off-track': {
		id: 'seaech-page.townsquare.api.goal-state.off-track',
		defaultMessage: 'Off track',
		description: 'Label of Off track state',
	},
	'townsquare.api.goal-state.at-risk': {
		id: 'seaech-page.townsquare.api.goal-state.at-risk',
		defaultMessage: 'At risk',
		description: 'Label of At risk state',
	},
	'townsquare.api.goal-state.on-track': {
		id: 'seaech-page.townsquare.api.goal-state.on-track',
		defaultMessage: 'On track',
		description: 'Label of On track state',
	},
	'townsquare.api.goal-state.pending': {
		id: 'seaech-page.townsquare.api.goal-state.pending',
		defaultMessage: 'Pending',
		description: 'Label of Pending state',
	},
	'townsquare.api.goal-state.paused': {
		id: 'seaech-page.townsquare.api.goal-state.paused',
		defaultMessage: 'Paused',
		description: 'Label of Paused state',
	},
	'townsquare.api.goal-state.completed': {
		id: 'seaech-page.townsquare.api.goal-state.completed',
		defaultMessage: 'Completed',
		description: 'Label of Completed state',
	},
	'townsquare.api.goal-state.cancelled': {
		id: 'seaech-page.townsquare.api.goal-state.cancelled',
		defaultMessage: 'Cancelled',
		description: 'Label of Cancelled state',
	},
});
